import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import Done from './Done';
import store from '../../../store';

function DoneContainer({ onStepSet }) {
  const walletTotal = useSelector(store.select.wallet.walletTotal);
  const cost = useSelector((state) => state.wallet.cost);
  const paymentTotal = useSelector(store.select.wallet.paymentTotal);
  const returnTotal = useSelector(store.select.wallet.returnTotal);
  const onDone = useCallback(() => {
    store.dispatch.history.save({
      wallet: walletTotal,
      cost,
      payment: paymentTotal,
      returns: returnTotal,
    });
    store.dispatch.wallet.applyTransaction();
    onStepSet(0);
  }, [cost, onStepSet, paymentTotal, returnTotal, walletTotal]);
  return <Done onDone={onDone} />;
}

DoneContainer.propTypes = {
  onStepSet: PropTypes.func.isRequired,
};

export default DoneContainer;
